import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoAlgobuilder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 30,
	viewBox: "0 0 36 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "logomark",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Polygon 2",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M11.6121 0.709961L22.1729 29.4638L10.8749 23.7499L0 29.6482L11.6121 0.709961Z",
				fill: "url(#paint0_linear_599_8913)"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M11.6121 0.709961L22.1729 29.4638L10.8749 23.7499L0 29.6482L11.6121 0.709961Z",
				fill: "url(#paint1_linear_599_8913)"
			})]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Union",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M27.3903 0.811976L14.1343 0.941406L24.5 29.4436L29.5 28.9393C33.0283 28.8201 35.7798 25.9689 35.6428 21.9142C35.5201 18.2828 33.1241 15.3447 30.0906 14.8564C32.6615 13.7695 34.4313 11.0971 34.3279 8.035C34.2012 4.28646 31.5213 0.988415 28.0006 0.811322L27.9999 0.806024L27.8972 0.807027C27.7659 0.802727 27.6334 0.802763 27.5 0.807272C27.4634 0.808509 27.4268 0.810078 27.3903 0.811976Z",
			fill: "url(#paint2_linear_599_8913)"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_599_8913",
			x1: 0,
			y1: .709961,
			x2: 51.5641,
			y2: 7.22248,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#0C111D" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .190698,
					stopColor: "#0C111D"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#155EEF"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_599_8913",
			x1: -9.50269,
			y1: -38.8389,
			x2: 33.5897,
			y2: -34.0495,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .343052,
				stopColor: "#1570EF"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#004CE0"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_599_8913",
			x1: 14.2076,
			y1: -2.61518,
			x2: 31.6828,
			y2: .49726,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .18,
				stopColor: "#0052CC"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#2684FF"
			})]
		})
	] })]
});
export default SvgLogoAlgobuilder;
